import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Alert,
  Typography,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Paper,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useEffect, useState, useMemo, useCallback } from "react";
import NomDomaineService from "../../api/services/NomDomaineService";
import MarqueService from "../../api/services/MarqueService";
import { styled, alpha } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ViewColumn, DensityMedium, Search } from "@mui/icons-material";
import { Tooltip, Divider, Menu, ListItemText } from "@mui/material";
import { Snackbar, Slide } from "@mui/material";
import { useLocation } from "react-router-dom";

const StyledCard = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha('#2a5fa9', 0.05)} 0%, ${alpha('#65b986', 0.05)} 100%)`,
  backdropFilter: 'blur(10px)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  borderRadius: '16px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0 20px 40px ${alpha('#2a5fa9', 0.1)}`,
    border: `1px solid ${alpha('#2a5fa9', 0.2)}`,
  },
  padding: '24px',
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '16px',
  overflowX: 'auto',
  background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
  backdropFilter: 'blur(10px)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: `0 8px 32px ${alpha('#000000', 0.1)}`,
  '& .MuiTableContainer-root': {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: alpha(theme.palette.divider, 0.1),
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: alpha('#2a5fa9', 0.3),
    borderRadius: '4px',
    '&:hover': {
      background: alpha('#2a5fa9', 0.5),
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiTableCell-root': {
      padding: '8px',
      fontSize: '0.75rem',
    },
    '& .MuiTableCell-head': {
      padding: '8px',
      fontSize: '0.7rem',
    },
  },
}));


const StyledTableHead = styled(TableHead)(({ theme }) => ({
  background: `linear-gradient(90deg, 
    #2a5fa9 0%, 
    #3a7fb5 20%,
    #4a9fc0 40%, 
    #5ab8a0 60%,
    #70bd8d 80%, 
    #8fc68b 100%)`,
  '& .MuiTableCell-head': {
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: 'none',
    padding: '20px 16px',
    whiteSpace: 'nowrap',
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`,
  padding: '16px',
  '&:nth-of-type(even)': {
    backgroundColor: alpha(theme.palette.action.hover, 0.02),
  },
}));

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: "none",
  borderRadius: "16px",
  background: `linear-gradient(135deg,
    ${alpha(theme.palette.background.paper, 0.9)} 0%,
    ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
  backdropFilter: "blur(10px)",
  boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
  width: "100%",
  height: "100%",
  "& .MuiDataGrid-main": {
    overflow: "visible",
  },
  "& .MuiDataGrid-columnHeaders": {
    background: `linear-gradient(90deg,
      #2a5fa9 0%, #3a7fb5 20%, #4a9fc0 40%,
      #5ab8a0 60%, #70bd8d 80%, #8fc68b 100%)`,
    color: "#ffffff",
    fontWeight: 600,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "none",
    minHeight: "56px",
    overflow: "visible",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`,
    padding: "16px",
    "&:nth-of-type(even)": {
      backgroundColor: alpha(theme.palette.action.hover, 0.02),
    },
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "none",
    background: `linear-gradient(135deg, #fcfdff 0%, #f6f9fa 100%)`,
    color: theme.palette.text.primary,
  },
  "& .MuiCheckbox-root": {
    color: `${theme.palette.primary.main} !important`,
  },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: alpha(theme.palette.divider, 0.1),
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: alpha("#2a5fa9", 0.3),
      borderRadius: "4px",
      "&:hover": {
        background: alpha("#2a5fa9", 0.5),
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
      padding: "8px",
      fontSize: "0.75rem",
    },
  },
}));


const SectionTitle = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(135deg, #2a5fa9 0%, #65b986 100%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 700,
  fontSize: '1.5rem',
  marginBottom: '24px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  background: alpha('#2a5fa9', 0.1),
  color: '#2a5fa9',
  '&:hover': {
    background: alpha('#2a5fa9', 0.2),
    transform: 'scale(1.1)',
  },
  '&:disabled': {
    background: alpha(theme.palette.action.disabled, 0.1),
    color: theme.palette.action.disabled,
  },
  transition: 'all 0.2s ease',
}));





const calculateRenewalDate = (periodicite) => {
  if (!periodicite) return "";
  const years = parseInt(periodicite.match(/\d+/)[0], 10);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const renewalDate = new Date(today);
  renewalDate.setFullYear(today.getFullYear() + years);
  return renewalDate.toISOString().split("T")[0];
};

const calculatePeriodicity = (renewalDate) => {
  if (!renewalDate) return "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const renewal = new Date(renewalDate);
  const years = renewal.getFullYear() - today.getFullYear();
  if (years < 1 || years > 10) {
    return "";
  }
  return `${years} an(s)`;
};
const CustomToolbar = ({ setAnchorElColumns, setAnchorElDensity }) => {
  const theme = useTheme();
  return (
    <Box sx={{
      p: 1, display: "flex", alignItems: "center",
      background: alpha(theme.palette.background.paper, 0.8),
      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    }}>
      <Box display="flex" gap={1}>
        <Tooltip title="Colonnes">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <IconButton onClick={(e) => setAnchorElColumns(e.currentTarget)} size="small">
              <ViewColumn fontSize="small" />
            </IconButton>
            <Typography variant="caption" sx={{ fontWeight: 600, color: '#000000', userSelect: 'none' }}>
              Colonnes
            </Typography>
          </Box>
        </Tooltip>
        <Tooltip title="Densité">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <IconButton onClick={(e) => setAnchorElDensity(e.currentTarget)} size="small">
              <DensityMedium fontSize="small" />
            </IconButton>
            <Typography variant="caption" sx={{ fontWeight: 600, color: '#000000', userSelect: 'none' }}>
              Densité
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

const NomsDomaines = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const role = localStorage.getItem("user_role") || "admin";
  const token = localStorage.getItem("token");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    try {
      const saved = localStorage.getItem("nomsdomaines_column_visibility");
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });

  const [density, setDensity] = useState(() => {
    return localStorage.getItem("nomsdomaines_density") || 'standard';
  });
  const [proprietaires, setProprietaires] = useState([]);
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [marques, setMarques] = useState([]);
  const [marquesFiltrees, setMarquesFiltrees] = useState([]);
  const [hebergeurs, setHebergeurs] = useState([]);
  const [numerosInternes, setNumerosInternes] = useState([]);
  const [nomsDomaines, setNomsDomaines] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [selectedNomsDomaine, setSelectedNomsDomaine] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [firstErrorField, setFirstErrorField] = useState("");
  const [filterSociete, setFilterSociete] = useState("");
  const [uniqueSocietes, setUniqueSocietes] = useState([]);
  const [societes, setSocietes] = useState([]);
  const [marqueSearch, setMarqueSearch] = useState("");
  const [comptesComptables, setComptesComptables] = useState([]);
  const [loadingComptes, setLoadingComptes] = useState(false);
  const [comptesComptablesEdit, setComptesComptablesEdit] = useState([]);
  const [loadingComptesEdit, setLoadingComptesEdit] = useState(false);
  const [customCompteComptableAdd, setCustomCompteComptableAdd] = useState(false);
  const [customCompteComptableEdit, setCustomCompteComptableEdit] = useState(false);
  const [customProprietaireAdd, setCustomProprietaireAdd] = useState(false);
  const [customUtilisateurAdd, setCustomUtilisateurAdd] = useState(false);
  const [customProprietaireEdit, setCustomProprietaireEdit] = useState(false);
  const [customUtilisateurEdit, setCustomUtilisateurEdit] = useState(false);
  const [numeroInterneSearch, setNumeroInterneSearch] = useState("");
  const [anchorElColumns, setAnchorElColumns] = useState(null);
  const [anchorElDensity, setAnchorElDensity] = useState(null);
  const [columnSearch, setColumnSearch] = useState("");
  const [newNomsDomaine, setNewNomsDomaine] = useState({
    numero_interne: "",
    nom_domaine: "",
    proprietaire: "",
    utilisateur: "",
    marque: "",
    statut: "",
    date_renouvellement: "",
    hebergeur: "",
    renouvellement_ht: "",
    automatique: false,
    periodicite: "",
    commentaires: "",
    compte_comptable: "",
    compte_comptable_id: "",
    compte_comptable_manuel: "",
    societe_id: "",
  });
  const [updatedNomsDomaine, setUpdatedNomsDomaine] = useState({
    id: "",
    numero_interne: "",
    nom_domaine: "",
    proprietaire: "",
    utilisateur: "",
    marque: "",
    statut: "",
    date_renouvellement: "",
    hebergeur: "",
    renouvellement_ht: "",
    automatique: false,
    periodicite: "",
    commentaires: "",
    compte_comptable: "",
    compte_comptable_id: "",
    compte_comptable_manuel: "",
    societe_id: "",
  });
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = (data, isAdd = true) => {
    const errors = {};

    if (!data.societe_id) {
      errors.societe_id = "La société est requise.";
    }

    // Autres champs obligatoires (communs à tous les rôles)
    if (!data.nom_domaine?.trim()) {
      errors.nom_domaine = "Le nom de domaine est requis.";
    }
    if (!data.compte_comptable_id && !data.compte_comptable_manuel?.trim()) {
      errors.compte_comptable_id = "Le compte comptable est requis.";
    }
    // Validation du renouvellement automatique
    if (data.automatique) {
      if (!data.periodicite) {
        errors.periodicite = "La périodicité est requise pour le renouvellement automatique.";
      }
      if (data.date_renouvellement) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (new Date(data.date_renouvellement) < today) {
          errors.date_renouvellement = "La date de renouvellement ne peut pas être dans le passé.";
        }
      }
    }

    return errors;
  };
  useEffect(() => {
    try {
      localStorage.setItem(
        "nomsdomaines_column_visibility",
        JSON.stringify(columnVisibilityModel)
      );
    } catch (e) {
      console.error("Erreur sauvegarde visibilité colonnes :", e);
    }
  }, [columnVisibilityModel]);

  useEffect(() => {
    if (snackbarOpen && firstErrorField && snackbarSeverity === "error") {
      setTimeout(() => {
        const selectors = {
          nom_domaine: '[label="Nom de Domaine"]',
          societe_id: '[label="Société"]',
          compte_comptable: '[label="Compte Comptable"]',
          periodicite: '[label="Périodicité"]',
          date_renouvellement: '[label="Date Renouvellement"]',
        };
        const selector = selectors[firstErrorField];
        const element = document.querySelector(selector);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          const input = element.closest('div')?.querySelector('input, div[role="button"]');
          input?.focus?.();
        }
      }, 100);
    }
  }, [snackbarOpen, firstErrorField, snackbarSeverity]);

  const fetchNomDomaines = async (societeId = null) => {
    setIsLoading(true);
    try {
      const params = societeId ? { societe_id: societeId } : {};
      const response = await NomDomaineService.getAllNomsDomaine(role, params);

      const noms = Array.isArray(response.nomsDomaine) ? response.nomsDomaine : [];
      const marquesList = Array.isArray(response.marques) ? response.marques : [];

      setNomsDomaines(
        noms.map(nd => ({
          ...nd,
          societe_nom: nd.societe?.nom || nd.societe_nom || "Société inconnue",
          societe_id: nd.societe?.id || nd.societe_id || null,
        }))
      );

      if (response.societes && response.societes.length > 0) {
        setSocietes(response.societes);
      } else {
        const societesMap = new Map();
        noms.forEach(nd => {
          const id = nd.societe?.id || nd.societe_id;
          const nom = nd.societe?.nom || nd.societe_nom;
          if (id && nom) societesMap.set(id, { id, nom });
        });
        setSocietes(Array.from(societesMap.values()).sort((a, b) => a.nom.localeCompare(b.nom)));
      }

      const societesMap = new Map();
      noms.forEach(nd => {
        const id = nd.societe?.id || nd.societe_id;
        const nom = nd.societe?.nom || nd.societe_nom;
        if (id && nom) societesMap.set(id, { id, nom });
      });
      setUniqueSocietes(Array.from(societesMap.values()).sort((a, b) => a.nom.localeCompare(b.nom)));

      setMarques(marquesList.map((m, idx) => ({
        id: m.id ?? idx + 1,
        nom: m.nom,
        numero_marque: m.numero_marque || "",
        zone_de_protection: m.zone_de_protection || "",
      })));
      const mapUnique = (array, key, nameField = "nom") => {
        const unique = [...new Set(array.map(item => item[key]).filter(Boolean))];
        return unique.map((value, idx) => ({ id: idx + 1, [nameField]: value }));
      };

      setNumerosInternes(mapUnique(noms, "numero_interne", "numero"));
      setProprietaires(mapUnique(noms, "proprietaire"));
      setUtilisateurs(mapUnique(noms, "utilisateur"));
      setHebergeurs(mapUnique(noms, "hebergeur"));

      setError("");
    } catch (err) {
      setError(err.message || "Erreur lors de la récupération des noms de domaine.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNomDomaines(filterSociete || null);
  }, [filterSociete, role]);

  const chargerComptesComptables = async (societeId, isEdit = false) => {
    if (!societeId) {
      isEdit ? setComptesComptablesEdit([]) : setComptesComptables([]);
      return;
    }
    isEdit ? setLoadingComptesEdit(true) : setLoadingComptes(true);
    try {
      const data = await NomDomaineService.getComptesComptables(role, societeId);
      isEdit ? setComptesComptablesEdit(data) : setComptesComptables(data);
    } catch (err) {
      setSnackbarMessage("Impossible de charger le plan comptable pour cette société.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      isEdit ? setComptesComptablesEdit([]) : setComptesComptables([]);
    } finally {
      isEdit ? setLoadingComptesEdit(false) : setLoadingComptes(false);
    }
  };

  // Marques filtrées pour le formulaire d'AJOUT
  useEffect(() => {
    if (!newNomsDomaine.societe_id) {
      setMarquesFiltrees([]);
      return;
    }
    MarqueService.getMarques(role, token, newNomsDomaine.societe_id)
      .then((res) => {
        const list = Array.isArray(res) ? res : res.resultats || [];
        setMarquesFiltrees(list);
      })
      .catch(() => setMarquesFiltrees([]));
  }, [newNomsDomaine.societe_id]);

  // Marques filtrées pour le formulaire de MODIFICATION
  useEffect(() => {
    if (!updatedNomsDomaine.societe_id) {
      setMarquesFiltrees([]);
      return;
    }
    MarqueService.getMarques(role, token, updatedNomsDomaine.societe_id)
      .then((res) => {
        const list = Array.isArray(res) ? res : res.resultats || [];
        setMarquesFiltrees(list);
      })
      .catch(() => setMarquesFiltrees([]));
  }, [updatedNomsDomaine.societe_id]);


  const handleDeleteClick = (nomsDomaine) => {
    setSelectedNomsDomaine(nomsDomaine);
    setOpenDelete(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedNomsDomaine?.id) return setError("Aucun nom de domaine sélectionné pour la suppression.");
    try {
      await NomDomaineService.deleteNomDomaine(role, selectedNomsDomaine.id);
      setOpenDelete(false);
      setSuccess("Nom de domaine supprimé avec succès !");
      await fetchNomDomaines();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(err.message || "Erreur lors de la suppression du nom de domaine.");
    }
  };

  const location = useLocation();

  // Highlight
  const [highlightId, setHighlightId] = useState(null);

  const [filterFromAlerte, setFilterFromAlerte] = useState(false);
  const [alerteFilterNom, setAlerteFilterNom] = useState("");

  useEffect(() => {
    if (!location.state?.highlightId || nomsDomaines.length === 0) return;

    const id = location.state.highlightId;
    const nomDomaine = location.state.highlightItem;

    if (nomDomaine) {
      // Mode filtre alerte
      setAlerteFilterNom(nomDomaine);
      setFilterFromAlerte(true);
    } else {
      setFilterFromAlerte(false);
    }

    setHighlightId(id);

    // Scroll vers la ligne
    setTimeout(() => {
      const row = document.querySelector(`[data-id="${id}"]`);
      if (row) {
        row.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 800);

    // Retirer highlight après 10s
    setTimeout(() => setHighlightId(null), 10000);


  }, [location.state, nomsDomaines]);
  const handleAddClick = () => {
    setNewNomsDomaine({
      numero_interne: "",
      nom_domaine: "",
      proprietaire: "",
      utilisateur: "",
      marque: "",
      statut: "",
      date_renouvellement: "",
      hebergeur: "",
      renouvellement_ht: "",
      automatique: false,
      periodicite: "",
      commentaires: "",
      compte_comptable: "",
      compte_comptable_id: "",
      compte_comptable_manuel: "",
      societe_id: "",
    });
    setNewNomsDomaine({});
    setComptesComptables([]);
    setCustomCompteComptableAdd(false);
    setCustomProprietaireAdd(false);
    setCustomUtilisateurAdd(false);
    setFormErrors({});
    setOpenAdd(true);
  };
  const handleAddConfirm = async () => {
    const errors = validateForm(newNomsDomaine);
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstErrorKey = Object.keys(errors)[0];
      setSnackbarMessage(errors[firstErrorKey]);
      setSnackbarSeverity("error");
      setFirstErrorField(firstErrorKey);
      setSnackbarOpen(true);
      return;
    }

    try {
      const payload = { ...newNomsDomaine };
      if (payload.compte_comptable_id) {
        payload.compte_comptable = undefined;
      } else {
        payload.compte_comptable = payload.compte_comptable_manuel || "";
      }
      delete payload.compte_comptable_manuel;
      await NomDomaineService.createNomDomaine(role, payload);
      setOpenAdd(false);
      setSnackbarMessage("Nom de domaine ajouté avec succès !");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormErrors({});
      await fetchNomDomaines();
    } catch (err) {
      setSnackbarMessage(err.message || "Erreur lors de l'ajout.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleUpdateClick = (nomsDomaine) => {
    const dateRenouvellement = nomsDomaine.date_renouvellement
      ? new Date(nomsDomaine.date_renouvellement).toISOString().split("T")[0]
      : "";
    const periodiciteFormatted = nomsDomaine.periodicite
      ? `${nomsDomaine.periodicite}`.includes("an")
        ? nomsDomaine.periodicite
        : `${nomsDomaine.periodicite} an(s)`
      : "";
    setUpdatedNomsDomaine({
      id: nomsDomaine.id || "",
      numero_interne: nomsDomaine.numero_interne || "",
      nom_domaine: nomsDomaine.nom_domaine || "",
      proprietaire: nomsDomaine.proprietaire || "",
      utilisateur: nomsDomaine.utilisateur || "",
      marque: nomsDomaine.marque || "",
      statut: nomsDomaine.statut || "Actif",
      date_renouvellement: dateRenouvellement,
      hebergeur: nomsDomaine.hebergeur || "",
      renouvellement_ht: nomsDomaine.renouvellement_ht || "",
      automatique: nomsDomaine.automatique || false,
      periodicite: periodiciteFormatted,
      commentaires: nomsDomaine.commentaires || "",
      compte_comptable: nomsDomaine.compte_comptable || "",
      compte_comptable_id: nomsDomaine.compte_comptable_id || "",
      compte_comptable_manuel: nomsDomaine.compte_comptable_id
        ? ""
        : (typeof nomsDomaine.compte_comptable === "string" ? nomsDomaine.compte_comptable : ""),
      societe_id: nomsDomaine.societe_id || "",
    });
    setFormErrors({})
    setCustomCompteComptableEdit(
      !nomsDomaine.compte_comptable_id && typeof nomsDomaine.compte_comptable === "string" && nomsDomaine.compte_comptable.trim() !== ""
    );
    chargerComptesComptables(nomsDomaine.societe_id, true);
    setOpenUpdate(true);
    setCustomProprietaireEdit(false);
    setCustomUtilisateurEdit(false);
  };

  const handleUpdateConfirm = async () => {
    const errors = validateForm(updatedNomsDomaine);
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstErrorKey = Object.keys(errors)[0];
      setSnackbarMessage(errors[firstErrorKey]);
      setSnackbarSeverity("error");
      setFirstErrorField(firstErrorKey);
      setSnackbarOpen(true);
      return;
    }

    try {
      const payload = { ...updatedNomsDomaine };
      if (payload.compte_comptable_id) {
        payload.compte_comptable = undefined;
      } else {
        payload.compte_comptable = payload.compte_comptable_manuel || "";
      }
      delete payload.compte_comptable_manuel;
      await NomDomaineService.updateNomDomaine(role, updatedNomsDomaine.id, payload);
      setOpenUpdate(false);
      setSnackbarMessage("Nom de domaine mis à jour avec succès !");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormErrors({});
      await fetchNomDomaines();
    } catch (err) {
      setSnackbarMessage(err.message || "Erreur lors de la mise à jour.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleCancelUpdate = () => {
    setOpenUpdate(false);
    setCustomProprietaireEdit(false);
    setCustomUtilisateurEdit(false);
    setCustomCompteComptableEdit(false);
    setUpdatedNomsDomaine({
      id: "",
      numero_interne: "",
      nom_domaine: "",
      proprietaire: "",
      utilisateur: "",
      marque: "",
      statut: "",
      date_renouvellement: "",
      hebergeur: "",
      renouvellement_ht: "",
      automatique: false,
      periodicite: "",
      commentaires: "",
      compte_comptable: "",
      compte_comptable_id: "",
      compte_comptable_manuel: "",
      societe_id: "",
    });
  };

  const handleDownloadExcel = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const timestamp = `${pad(now.getDate())}_${pad(now.getMonth() + 1)}_${now.getFullYear()}_${pad(now.getHours())}_${pad(now.getMinutes())}_${pad(now.getSeconds())}`;
    const fileName = `noms_domaines_${timestamp}.csv`;

    const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "");
    const fmtNum = (n) =>
      n !== null && n !== undefined && n !== "" ? String(n).replace(".", ",") : "";
    const fmtCompte = (cc) => {
      if (!cc) return "";
      if (typeof cc === "string") return cc;
      return `${cc.code} - ${cc.libelle}`;
    };

    const headers = [
      "Société",
      "Numéro Interne",
      "Compte Comptable",
      "Nom de Domaine",
      "Propriétaire",
      "Utilisateur",
      "Marque",
      "Statut",
      "Date Renouvellement",
      "Hébergeur",
      "Renouvellement HT",
      "Renouvellement Automatique",
      "Périodicité",
      "Commentaires",
    ];

    const data = filteredRows.map((row) => [
      row.societe_nom || "",
      row.numero_interne || "",
      fmtCompte(row.compte_comptable),
      row.nom_domaine || "",
      row.proprietaire || "",
      row.utilisateur || "",
      row.marque || "",
      row.statut || "",
      fmtDate(row.date_renouvellement),
      row.hebergeur || "",
      fmtNum(row.renouvellement_ht),
      row.automatique ? "Oui" : "Non",
      row.periodicite || "",
      row.commentaires || "",
    ]);

    const csvContent =
      "\uFEFF" +
      [
        headers.map((h) => `"${h}"`).join(";"),
        ...data.map((row) =>
          row
            .map((cell) => `"${String(cell).replace(/"/g, '""').replace(/\n|\r/g, " ")}"`)
            .join(";")
        ),
      ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  const columns = [
    {
      field: "compte_comptable",
      headerName: "Compte Comptable",
      flex: 2,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        const cc = params.row.compte_comptable;
        if (!cc) return "-";
        if (typeof cc === "string") return cc;
        return `${cc.code} - ${cc.libelle}`;
      },
    },
    {
      field: "numero_interne", headerName: "Numéro Interne",
      width: 150,
      sortable: false
    },

    {
      field: "nom_domaine", headerName: "Nom de Domaine",
      width: 150,
      sortable: false
    },

    {
      field: "proprietaire",
      headerName: "Propriétaire",
      width: 150,
      sortable: false,
    },
    {
      field: "marque",
      headerName: "Marque",

      width: 150,
      sortable: false,
    },
    {
      field: "statut", headerName: "Statut",
      width: 150,
      sortable: false
    },
    {
      field: "date_renouvellement",
      headerName: "Date Renouvellement",
      flex: 2,
      minWidth: 180,
      renderCell: (params) => {
        const date = params.row.date_renouvellement ? new Date(params.row.date_renouvellement) : null;
        return <Typography variant="body2">{date ? date.toLocaleDateString() : "-"}</Typography>;
      },
      sortable: true,
    },
    {
      field: "hebergeur",
      headerName: "Hébergeur",
      width: 150,
      sortable: false,
    },
    {
      field: "renouvellement_ht",
      headerName: "Renouvellement HT",
      width: 170,
      sortable: false,
    },
    // {
    //   field: "automatique",
    //   headerName: "Automatique",
    //   flex: 1,
    //   renderCell: (params) => <Typography variant="body2">{params.row.automatique ? "Oui" : "Non"}</Typography>,
    // },
    {
      field: "periodicite",
      headerName: "Périodicité",
      width: 150,
      sortable: false,
    },
    {
      field: "societe_nom",
      headerName: "Société",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.societe_nom || "-"}
        </Typography>
      ),
      sortable: false,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Box display="flex" gap={0.5}>
          <StyledIconButton
            onClick={() => handleUpdateClick(params.row)}
            size="small"
            title="Modifier"
          >
            <Edit fontSize="small" />
          </StyledIconButton>
          <StyledIconButton
            onClick={() => handleDeleteClick(params.row)}
            size="small"
            title="Supprimer"
            sx={{ color: theme.palette.error.main }}
          >
            <Delete fontSize="small" />
          </StyledIconButton>
        </Box>
      ),
      sortable: false,
    },
  ];

  const filteredRows = useMemo(() => {
    let result = nomsDomaines;

    // Filtre recherche globale
    const searchLower = search.toLowerCase();
    result = result.filter(nd =>
      Object.values(nd).some(v =>
        v?.toString().toLowerCase().includes(searchLower)
      )
    );

    // Filtre société
    if (filterSociete) {
      result = result.filter(nd => nd.societe_id == filterSociete);
    }

    //  Filtre depuis alerte (nom de domaine)
    if (filterFromAlerte && alerteFilterNom) {
      result = result.filter(nd =>
        nd.nom_domaine?.toLowerCase().includes(alerteFilterNom.toLowerCase())
      );
    }

    return result;

  }, [
    nomsDomaines,
    search,
    filterSociete,
    filterFromAlerte,
    alerteFilterNom
  ]);


  return (
    <Box
      sx={{
        m: { xs: 1, sm: 2, md: 3 },
      }}
    >
      <Header
        title="NOMS DE DOMAINE"
        subtitle="Gestion centralisé des noms de domaine"
      />


      <StyledCard>
        {/* Barre de filtres et boutons */}
        <Box
          mb={2}
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          gap={2}
          alignItems={{ xs: 'stretch', sm: 'center' }}
        >
          <TextField
            label="Rechercher..."
            variant="outlined"
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              backgroundColor: alpha(theme.palette.background.paper, 0.95),
              borderRadius: '8px',
              flex: 1,
              width: { xs: '100%', sm: 'auto' },
            }}
          />

          {(role === "admin" || role === "gestionnaire") && (
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="filter-societe-label">Société</InputLabel>
              <Select
                labelId="filter-societe-label"
                value={filterSociete}
                label="Société"
                onChange={(e) => setFilterSociete(e.target.value)}
                sx={{
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  borderRadius: '8px',
                  minWidth: 180,
                }}
              >
                <MenuItem value="">Toutes mes sociétés</MenuItem>
                {societes.map((soc) => (
                  <MenuItem key={soc.id} value={soc.id}>
                    {soc.nom}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={1} width={{ xs: '100%', sm: 'auto' }}>
            <Button
              variant="contained"
              onClick={handleAddClick}
              sx={{
                borderRadius: '8px',
                background: `linear-gradient(135deg, #2a5fa9 0%, #4cbed8 100%)`,
                color: '#ffffff',
                '&:hover': { background: `linear-gradient(135deg, #4cbed8 0%, #65b986 100%)`, transform: 'scale(1.05)' },
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Ajouter un nom de domaine
            </Button>
            <Button
              variant="contained"
              onClick={handleDownloadExcel}
              sx={{
                borderRadius: '8px',
                background: `linear-gradient(135deg, #2a5fa9 0%, #4cbed8 100%)`,
                color: '#ffffff',
                '&:hover': { background: `linear-gradient(135deg, #4cbed8 0%, #65b986 100%)`, transform: 'scale(1.05)' },
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Télécharger Excel
            </Button>
          </Box>
        </Box>

        {/* MENU COLONNES */}
        <Menu
          anchorEl={anchorElColumns}
          open={Boolean(anchorElColumns)}
          onClose={() => setAnchorElColumns(null)}
          disableAutoFocusItem
          keepMounted
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{ sx: { maxHeight: 500, width: 320, '& .MuiList-root': { p: 0 } } }}
        >
          <Box sx={{ px: 1, pt: 1 }}>
            <TextField
              fullWidth
              placeholder="Rechercher une colonne"
              size="small"
              value={columnSearch}
              onChange={(e) => setColumnSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              InputProps={{ startAdornment: <Search fontSize="small" sx={{ mr: 0.5 }} /> }}
            />
          </Box>

          <Box sx={{ maxHeight: 320, overflowY: 'auto', px: 1, py: 1 }}>
            {[
              { field: "compte_comptable", headerName: "Compte Comptable" },
              { field: "numero_interne", headerName: "Numéro Interne" },
              { field: "nom_domaine", headerName: "Nom de Domaine" },
              { field: "proprietaire", headerName: "Propriétaire" },
              { field: "marque", headerName: "Marque" },
              { field: "statut", headerName: "Statut" },
              { field: "date_renouvellement", headerName: "Date Renouvellement" },
              { field: "hebergeur", headerName: "Hébergeur" },
              { field: "renouvellement_ht", headerName: "Renouvellement HT" },
              { field: "periodicite", headerName: "Périodicité" },
              { field: "societe_nom", headerName: "Société" },
              { field: "actions", headerName: "Actions" },
            ]
              .filter(col => col.headerName.toLowerCase().includes(columnSearch.toLowerCase()))
              .map((col) => (
                <Box
                  key={col.field}
                  onClick={() => {
                    setColumnVisibilityModel(prev => ({
                      ...prev,
                      [col.field]: !(prev[col.field] ?? true)
                    }));
                  }}
                  sx={{
                    py: 0.75, px: 1.5, borderRadius: 1, mb: 0.25,
                    display: 'flex', alignItems: 'center', cursor: 'pointer',
                    '&:hover': { backgroundColor: 'action.hover' },
                  }}
                >
                  <Box sx={{
                    width: 34, height: 20, borderRadius: '10px', mr: 1.5,
                    backgroundColor: (columnVisibilityModel[col.field] ?? true) ? '#1976d2' : '#e0e0e0',
                    position: 'relative'
                  }}>
                    <Box sx={{
                      width: 16, height: 16, borderRadius: '50%', backgroundColor: 'white',
                      position: 'absolute', top: '2px',
                      left: (columnVisibilityModel[col.field] ?? true) ? '16px' : '2px'
                    }} />
                  </Box>
                  <Typography sx={{ fontSize: '0.875rem' }}>{col.headerName}</Typography>
                </Box>
              ))}
          </Box>

          <Divider sx={{ my: 0.5 }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1.5 }}>
            <Button size="small" onClick={() => setColumnVisibilityModel({
              compte_comptable: false, numero_interne: false, nom_domaine: false,
              proprietaire: false, marque: false, statut: false, date_renouvellement: false,
              hebergeur: false, renouvellement_ht: false, periodicite: false,
              societe_nom: false, actions: false
            })}>
              MASQUER TOUT
            </Button>
            <Button size="small" onClick={() => setColumnVisibilityModel({})}>
              AFFICHER TOUT
            </Button>
          </Box>
        </Menu>

        {/* Menu Densité */}
        <Menu
          anchorEl={anchorElDensity}
          open={Boolean(anchorElDensity)}
          onClose={() => setAnchorElDensity(null)}
        >
          <MenuItem onClick={() => { setDensity('compact'); setAnchorElDensity(null); }}>Compact</MenuItem>
          <MenuItem onClick={() => { setDensity('standard'); setAnchorElDensity(null); }}>Standard</MenuItem>
          <MenuItem onClick={() => { setDensity('comfortable'); setAnchorElDensity(null); }}>Confortable</MenuItem>
        </Menu>
        {filterFromAlerte && alerteFilterNom && (
          <Alert
            severity="info"
            icon={<Search />}
            sx={{ mb: 2, borderRadius: "12px" }}
            action={
              <Button
                color="inherit"
                size="small"
                variant="outlined"
                onClick={() => {
                  setFilterFromAlerte(false);
                  setAlerteFilterNom("");
                  setHighlightId(null);
                }}
              >
                Afficher tous les noms de domaine
              </Button>
            }
          >
            Affichage filtré pour le nom de domaine : <strong>{alerteFilterNom}</strong>
          </Alert>
        )}

        {/* DataGrid */}
        <Box sx={{ width: "100%", mt: 2, height: "70vh", minHeight: 600, overflow: "hidden" }}>
          <StyledDataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={(row) => row.id}
            pagination
            paginationMode="client"
            initialState={{ pagination: { paginationModel: { pageSize: 20, page: 0 } } }}
            pageSizeOptions={[10, 20, 50, 100]}
            loading={isLoading}
            disableSelectionOnClick
            density={density}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={setColumnVisibilityModel}
            disableColumnSorting={true}
            disableColumnMenu={true}
            getRowClassName={(params) =>
              params.id === highlightId ? "highlighted-row" : ""
            }
            components={{
              Toolbar: useCallback(() => (
                <CustomToolbar
                  setAnchorElColumns={setAnchorElColumns}
                  setAnchorElDensity={setAnchorElDensity}
                />
              ), []),
            }}
            sx={{
              width: "100% !important",
              height: "100% !important",
              "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": { visibility: "visible" },
              "& .MuiDataGrid-sortIcon": { display: "none !important" },
              "& .highlighted-row": {
                backgroundColor: `${alpha("#f59e0b", 0.25)} !important`,
                outline: `2px solid #f59e0b`,
                outlineOffset: "-2px",
                transition: "background-color 0.5s ease",
              },
            }}
          />
        </Box>
      </StyledCard>

      <Dialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            background: `linear-gradient(145deg, #ffffff 0%, #f8faff 100%)`,
            borderRadius: '20px',
            border: `1px solid ${alpha('#2a5fa9', 0.15)}`,
            boxShadow: `0 24px 60px ${alpha('#2a5fa9', 0.18)}`,
            overflow: 'hidden',
          }
        }}
      >
        <DialogTitle>
          <SectionTitle>Ajouter un nom de domaine</SectionTitle>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mb: 2, mt: 1 }}>
            <InputLabel>Numéro Interne</InputLabel>
            <Select
              value={newNomsDomaine.numero_interne}
              onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, numero_interne: e.target.value })}
              label="Numéro Interne"
              renderValue={() => newNomsDomaine.numero_interne || ""}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              MenuProps={{
                PaperProps: {
                  sx: { maxHeight: 320, '& .MuiList-root': { pt: 0 } },
                },
                disableAutoFocusItem: true,
                autoFocus: false,
              }}
              onOpen={() => setNumeroInterneSearch("")}
            >
              <Box
                component="li"
                sx={{
                  position: 'sticky', top: 0, zIndex: 100,
                  backgroundColor: theme.palette.background.paper,
                  p: 1, listStyle: 'none',
                  // borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
                onClickCapture={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Rechercher un numéro interne..."
                  value={numeroInterneSearch}
                  onChange={(e) => setNumeroInterneSearch(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  autoFocus
                  InputProps={{
                    startAdornment: <Search fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                    '& .MuiInputBase-root': { backgroundColor: alpha(theme.palette.background.paper, 1) },
                  }}
                />
              </Box>

              {numerosInternes
                .filter((num) => num.numero?.toLowerCase().includes(numeroInterneSearch.toLowerCase()))
                .map((num) => {
                  const isSelected = newNomsDomaine.numero_interne === num.numero;
                  return (
                    <MenuItem
                      key={num.id}
                      value={num.numero}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5, py: 1,
                        '&.Mui-selected': { backgroundColor: 'transparent !important' },
                        '&.Mui-selected:hover': { backgroundColor: `${alpha('#2a5fa9', 0.05)} !important` },
                      }}
                    >
                      <Box sx={{
                        width: 20, height: 20,
                        borderRadius: '50%',
                        border: `2px solid ${isSelected ? '#4cbed8' : alpha('#000', 0.2)}`,
                        backgroundColor: isSelected ? '#ffffff' : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, transition: 'all 0.2s ease',
                      }}>
                        {isSelected && (
                          <svg
                            viewBox="0 0 24 24"
                            width="13"
                            height="13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 13L9 18L20 6"
                              stroke="#4cbed8"
                              strokeWidth="3.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </Box>
                      <Typography variant="body2" fontWeight={500} noWrap>
                        {num.numero}
                      </Typography>
                    </MenuItem>
                  );
                })
              }

              {numerosInternes.filter((num) => num.numero?.toLowerCase().includes(numeroInterneSearch.toLowerCase())).length === 0 && (
                <MenuItem disabled>
                  <Typography variant="body2" color="text.secondary">Aucun numéro trouvé</Typography>
                </MenuItem>
              )}
            </Select>
          </FormControl>
          {/* === AJOUT : Champ Société === */}
          <FormControl fullWidth error={!!formErrors.societe_id} sx={{ mb: 2 }}>
            <InputLabel id="societe-add-label">Société *</InputLabel>
            <Select
              labelId="societe-add-label"
              value={newNomsDomaine.societe_id || ""}
              onChange={(e) => {
                const societeId = e.target.value;
                setNewNomsDomaine({ ...newNomsDomaine, societe_id: societeId, marque: "", compte_comptable_id: "" });
                chargerComptesComptables(societeId, false);
              }}
              label="Société *"
              sx={{
                backgroundColor: alpha(theme.palette.background.paper, 0.95),
                borderRadius: '8px'
              }}
            >
              <MenuItem value="">
                <em>Choisir une société</em>
              </MenuItem>
              {societes.map((soc) => (
                <MenuItem key={soc.id} value={soc.id}>
                  {soc.nom}
                </MenuItem>
              ))}
            </Select>
            {formErrors.societe_id && (
              <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                {formErrors.societe_id}
              </Typography>
            )}
          </FormControl>

          <TextField
            label="Nom de Domaine"
            variant="outlined"
            fullWidth
            value={newNomsDomaine.nom_domaine}
            onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, nom_domaine: e.target.value })}
            error={!!formErrors.nom_domaine}
            // helperText={formErrors.nom_domaine || " "}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            required
          />

          {!customCompteComptableAdd ? (
            <FormControl
              fullWidth
              sx={{ mb: 2 }}
              disabled={!newNomsDomaine.societe_id || loadingComptes}
              error={!!formErrors.compte_comptable_id}
            >
              <InputLabel id="compte-comptable-label">Compte Comptable *</InputLabel>
              <Select
                labelId="compte-comptable-label"
                value={newNomsDomaine.compte_comptable_id || ""}
                onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, compte_comptable_id: e.target.value })}
                label="Compte Comptable *"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              >
                <MenuItem value="" disabled>
                  {loadingComptes ? "Chargement..." : "Choisir un compte"}
                </MenuItem>
                {comptesComptables.map((c) => (
                  <MenuItem key={c.id} value={c.id}>{c.code} — {c.libelle}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomCompteComptableAdd(true);
                    setNewNomsDomaine({ ...newNomsDomaine, compte_comptable_id: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
              {!newNomsDomaine.societe_id && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5 }}>
                  Sélectionnez d'abord une société.
                </Typography>
              )}
              {formErrors.compte_comptable_id && (
                <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
                  {formErrors.compte_comptable_id}
                </Typography>
              )}
            </FormControl>
          ) : (
            <TextField
              label="Compte Comptable (saisie manuelle) *"
              variant="outlined"
              fullWidth
              autoFocus
              value={newNomsDomaine.compte_comptable_manuel || ""}
              onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, compte_comptable_manuel: e.target.value })}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              InputProps={{
                endAdornment: (
                  <Button
                    size="small"
                    onClick={() => { setCustomCompteComptableAdd(false); setNewNomsDomaine({ ...newNomsDomaine, compte_comptable_manuel: "" }); }}
                    sx={{ color: "error.main", minWidth: 'auto', fontSize: '0.75rem' }}
                  >
                    ✕
                  </Button>
                )
              }}
            />
          )}

          {/* PROPRIÉTAIRE ADD */}
          {!customProprietaireAdd ? (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ '&.Mui-focused': { color: '#2a5fa9' } }}>Propriétaire</InputLabel>
              <Select
                value={newNomsDomaine.proprietaire}
                onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, proprietaire: e.target.value })}
                label="Propriétaire"
                sx={{
                  borderRadius: '10px',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha('#2a5fa9', 0.2) },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9', borderWidth: 2 },
                }}
              >
                {proprietaires.map((p) => (
                  <MenuItem key={p.id} value={p.nom}>{p.nom}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomProprietaireAdd(true);
                    setNewNomsDomaine({ ...newNomsDomaine, proprietaire: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            <Box sx={{
              mb: 2,
              borderRadius: '12px',
              border: `1.5px solid ${alpha('#2a5fa9', 0.3)}`,
              background: `linear-gradient(135deg, ${alpha('#2a5fa9', 0.03)}, ${alpha('#4cbed8', 0.03)})`,
              p: 1.5,
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{
                  width: 6, height: 6, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#2a5fa9', letterSpacing: '0.4px', textTransform: 'uppercase', fontSize: '0.7rem' }}>
                  Propriétaire
                </Typography>
              </Box>
              <TextField
                label="Propriétaire"
                fullWidth
                autoFocus
                value={newNomsDomaine.proprietaire}
                onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, proprietaire: e.target.value })}
                placeholder="Entrez le nom du propriétaire..."
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: alpha('#2a5fa9', 0.25) },
                    '&:hover fieldset': { borderColor: '#2a5fa9' },
                    '&.Mui-focused fieldset': { borderColor: '#2a5fa9', borderWidth: 2 },
                  },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#2a5fa9' },
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      size="small"
                      onClick={() => { setCustomProprietaireAdd(false); setNewNomsDomaine({ ...newNomsDomaine, proprietaire: "" }); }}
                      sx={{
                        minWidth: 'auto', px: 1.5, py: 0.4,
                        borderRadius: '6px', fontSize: '0.72rem', fontWeight: 600,
                        color: theme.palette.error.main,
                        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
                        '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.08), borderColor: theme.palette.error.main },
                        whiteSpace: 'nowrap',
                      }}
                    >
                      ✕
                    </Button>
                  )
                }}
              />
            </Box>
          )}

          {/* UTILISATEUR ADD */}
          {!customUtilisateurAdd ? (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ '&.Mui-focused': { color: '#2a5fa9' } }}>Utilisateur</InputLabel>
              <Select
                value={newNomsDomaine.utilisateur}
                onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, utilisateur: e.target.value })}
                label="Utilisateur"
                sx={{
                  borderRadius: '10px',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha('#2a5fa9', 0.2) },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9', borderWidth: 2 },
                }}
              >
                {utilisateurs.map((u) => (
                  <MenuItem key={u.id} value={u.nom}>{u.nom}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomUtilisateurAdd(true);
                    setNewNomsDomaine({ ...newNomsDomaine, utilisateur: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            <Box sx={{
              mb: 2,
              borderRadius: '12px',
              border: `1.5px solid ${alpha('#4cbed8', 0.3)}`,
              background: `linear-gradient(135deg, ${alpha('#4cbed8', 0.03)}, ${alpha('#65b986', 0.03)})`,
              p: 1.5,
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{
                  width: 6, height: 6, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #4cbed8, #65b986)',
                }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#4cbed8', letterSpacing: '0.4px', textTransform: 'uppercase', fontSize: '0.7rem' }}>
                  Utilisateur
                </Typography>
              </Box>
              <TextField
                label="Utilisateur"
                fullWidth
                autoFocus
                value={newNomsDomaine.utilisateur}
                onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, utilisateur: e.target.value })}
                placeholder="Entrez le nom de l'utilisateur..."
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: alpha('#4cbed8', 0.25) },
                    '&:hover fieldset': { borderColor: '#4cbed8' },
                    '&.Mui-focused fieldset': { borderColor: '#4cbed8', borderWidth: 2 },
                  },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#4cbed8' },
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      size="small"
                      onClick={() => { setCustomUtilisateurAdd(false); setNewNomsDomaine({ ...newNomsDomaine, utilisateur: "" }); }}
                      sx={{
                        minWidth: 'auto', px: 1.5, py: 0.4,
                        borderRadius: '6px', fontSize: '0.72rem', fontWeight: 600,
                        color: theme.palette.error.main,
                        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
                        '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.08), borderColor: theme.palette.error.main },
                        whiteSpace: 'nowrap',
                      }}
                    >
                      ✕
                    </Button>
                  )
                }}
              />
            </Box>
          )}
          <FormControl fullWidth sx={{ mb: 2 }} disabled={!newNomsDomaine.societe_id}>
            <InputLabel>Marque</InputLabel>
            <Select
              value={newNomsDomaine.marque}
              onChange={() => { }} // neutralisé
              label="Marque"
              renderValue={() => newNomsDomaine.marque || ""}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 320,
                    '& .MuiList-root': { pt: 0 },
                  },
                },
                disableAutoFocusItem: true,
                autoFocus: false,
              }}
              onOpen={() => setMarqueSearch("")}
            >
              {/* Barre de recherche — ListSubheader reste toujours au-dessus */}
              <Box
                component="li"
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 100,
                  backgroundColor: theme.palette.background.paper,
                  p: 1,
                  listStyle: 'none',
                  // borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
                onClickCapture={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Rechercher une marque..."
                  value={marqueSearch}
                  onChange={(e) => setMarqueSearch(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  autoFocus
                  InputProps={{
                    startAdornment: <Search fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                    '& .MuiInputBase-root': { backgroundColor: alpha(theme.palette.background.paper, 1) },
                  }}
                />
              </Box>


              {/* Liste filtrée */}
              {marquesFiltrees
                .filter((m) => {
                  const zone = Array.isArray(m.zone_de_protection)
                    ? m.zone_de_protection.join(', ')
                    : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();

                  const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - '); return label?.toLowerCase().includes(marqueSearch.toLowerCase());
                })
                .map((m) => {
                  const zone = Array.isArray(m.zone_de_protection)
                    ? m.zone_de_protection.join(', ')
                    : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();

                  const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - '); const isSelected = newNomsDomaine.marque === label;
                  return (
                    <MenuItem
                      key={m.id}

                      value={label}
                      onClick={() => setNewNomsDomaine({
                        ...newNomsDomaine,
                        marque: newNomsDomaine.marque === label ? "" : label
                      })}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5, py: 1,
                        '&.Mui-selected': { backgroundColor: 'transparent !important' },
                        '&.Mui-selected:hover': { backgroundColor: `${alpha('#2a5fa9', 0.05)} !important` },
                      }}
                    >
                      <Box sx={{
                        width: 20, height: 20,
                        borderRadius: '50%',
                        border: `2px solid ${isSelected ? '#4cbed8' : alpha('#000', 0.2)}`,
                        backgroundColor: isSelected ? '#ffffff' : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, transition: 'all 0.2s ease',
                      }}>
                        {isSelected && (
                          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 13L9 18L20 6" stroke="#4cbed8" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, flexWrap: 'wrap' }}>
                        <Typography variant="body2" noWrap>
                          {m.nom}
                        </Typography>
                        {m.numero_marque && (
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#2a5fa9',
                              fontWeight: 600,
                              fontSize: '0.72rem',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            N° {m.numero_marque}
                          </Typography>
                        )}
                        {m.zone_de_protection && (
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              backgroundColor: alpha('#4cbed8', 0.12),
                              border: `1px solid ${alpha('#4cbed8', 0.35)}`,
                              borderRadius: '20px',
                              px: 0.9,
                              py: 0.15,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#2a9ab5',
                                fontWeight: 700,
                                fontSize: '0.68rem',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {Array.isArray(m.zone_de_protection)
                                ? m.zone_de_protection.join(', ')
                                : String(m.zone_de_protection).replace(/[\[\]"]/g, '').trim()
                              }                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </MenuItem>
                  );
                })
              }

              {marquesFiltrees.filter((m) => {
                const zone = Array.isArray(m.zone_de_protection)
                  ? m.zone_de_protection.join(', ')
                  : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();

                const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - '); return label?.toLowerCase().includes(marqueSearch.toLowerCase());
              }).length === 0 && (
                  <MenuItem disabled>
                    <Typography variant="body2" color="text.secondary">Aucune marque trouvée</Typography>
                  </MenuItem>
                )}

            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Statut</InputLabel>
            <Select
              value={newNomsDomaine.statut}
              onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, statut: e.target.value })}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              <MenuItem value="Actif">Actif</MenuItem>
              <MenuItem value="Non actif">Non actif</MenuItem>
              <MenuItem value="A fermer">A fermer</MenuItem>
              <MenuItem value="En attente">En attente</MenuItem>
              <MenuItem value="Expiré">Expiré</MenuItem>
              <MenuItem value="Renouvelé">Renouvelé</MenuItem>
              <MenuItem value="Non renouvelé">Non renouvelé</MenuItem>
              <MenuItem value="Suspendu">Suspendu</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Date Renouvellement"
            variant="outlined"
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            value={newNomsDomaine.date_renouvellement}
            onChange={(e) => {
              const newDate = e.target.value;
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              if (newDate && new Date(newDate) < today) {
                setError("La date de renouvellement ne peut pas être dans le passé.");
                return;
              }
              setError("");
              setNewNomsDomaine({
                ...newNomsDomaine,
                date_renouvellement: newDate,
                periodicite: newNomsDomaine.automatique ? calculatePeriodicity(newDate) : newNomsDomaine.periodicite,
              });
            }}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Hébergeur</InputLabel>
            <Select
              value={newNomsDomaine.hebergeur}
              onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, hebergeur: e.target.value })}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              {hebergeurs.map((h) => (
                <MenuItem key={h.id} value={h.nom}>{h.nom}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Renouvellement HT"
            variant="outlined"
            fullWidth

            value={newNomsDomaine.renouvellement_ht}
            onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, renouvellement_ht: e.target.value })}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={newNomsDomaine.automatique}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  const newPeriodicite = isChecked && !newNomsDomaine.periodicite ? "1 an(s)" : newNomsDomaine.periodicite;
                  setNewNomsDomaine({
                    ...newNomsDomaine,
                    automatique: isChecked,
                    periodicite: newPeriodicite,
                    date_renouvellement: isChecked ? calculateRenewalDate(newPeriodicite) : newNomsDomaine.date_renouvellement,
                  });
                }}
                color="primary"
              />
            }
            label="Renouvellement Automatique"
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Périodicité</InputLabel>
            <Select
              value={newNomsDomaine.periodicite}
              onChange={(e) => {
                const newPeriodicite = e.target.value;
                setNewNomsDomaine({
                  ...newNomsDomaine,
                  periodicite: newPeriodicite,
                  date_renouvellement: newNomsDomaine.automatique ? calculateRenewalDate(newPeriodicite) : newNomsDomaine.date_renouvellement,
                });
              }}
              disabled={!newNomsDomaine.automatique}
              error={!!formErrors.periodicite}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              {[...Array(10).keys()].map((i) => (
                <MenuItem key={i + 1} value={`${i + 1} an(s)`}>{i + 1} an(s)</MenuItem>
              ))}
            </Select>
            {formErrors.periodicite && (
              <Typography variant="caption" color="error" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                {formErrors.periodicite}
              </Typography>
            )}
          </FormControl>

          <TextField
            label="Commentaires"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={newNomsDomaine.commentaires}
            onChange={(e) => setNewNomsDomaine({ ...newNomsDomaine, commentaires: e.target.value })}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenAdd(false)}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
              },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleAddConfirm}
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '8px',
              background: alpha(theme.palette.primary.main, 0.8),
              '&:hover': {
                background: theme.palette.primary.main,
                transform: 'scale(1.05)',
              },
            }}
          >
            Ajouter
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={Slide}
        sx={{
          mt: 10,  // Augmenté pour être bien au-dessus du header
          zIndex: 9999  // Toujours au-dessus de tout
        }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          variant="filled"
          sx={{
            width: "100%",
            minWidth: 300,
            fontWeight: 600,
            fontSize: "0.95rem",
            boxShadow: `0 4px 20px ${alpha(
              snackbarSeverity === "error" ? theme.palette.error.main : theme.palette.success.main,
              0.3
            )}`,
            borderRadius: "12px",
            py: 1.5,
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={openUpdate}
        onClose={handleCancelUpdate}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          },
        }}
      >
        <DialogTitle>
          <SectionTitle>Mettre à jour le nom de domaine</SectionTitle>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mb: 2, mt: 1 }}>
            <InputLabel>Numéro Interne</InputLabel>
            <Select
              value={updatedNomsDomaine.numero_interne}
              onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, numero_interne: e.target.value })}
              label="Numéro Interne"
              renderValue={() => updatedNomsDomaine.numero_interne || ""}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              MenuProps={{
                PaperProps: {
                  sx: { maxHeight: 320, '& .MuiList-root': { pt: 0 } },
                },
                disableAutoFocusItem: true,
                autoFocus: false,
              }}
              onOpen={() => setNumeroInterneSearch("")}
            >
              <Box
                component="li"
                sx={{
                  position: 'sticky', top: 0, zIndex: 100,
                  backgroundColor: theme.palette.background.paper,
                  p: 1, listStyle: 'none',
                  // borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
                onClickCapture={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Rechercher un numéro interne..."
                  value={numeroInterneSearch}
                  onChange={(e) => setNumeroInterneSearch(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  autoFocus
                  InputProps={{
                    startAdornment: <Search fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                    '& .MuiInputBase-root': { backgroundColor: alpha(theme.palette.background.paper, 1) },
                  }}
                />
              </Box>

              {numerosInternes
                .filter((num) => num.numero?.toLowerCase().includes(numeroInterneSearch.toLowerCase()))
                .map((num) => {
                  const isSelected = updatedNomsDomaine.numero_interne === num.numero;
                  return (
                    <MenuItem
                      key={num.id}
                      value={num.numero}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5, py: 1,
                        '&.Mui-selected': { backgroundColor: 'transparent !important' },
                        '&.Mui-selected:hover': { backgroundColor: `${alpha('#2a5fa9', 0.05)} !important` },
                      }}
                    >
                      <Box sx={{
                        width: 20, height: 20,
                        borderRadius: '50%',
                        border: `2px solid ${isSelected ? '#4cbed8' : alpha('#000', 0.2)}`,
                        backgroundColor: isSelected ? '#ffffff' : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, transition: 'all 0.2s ease',
                      }}>
                        {isSelected && (
                          <svg
                            viewBox="0 0 24 24"
                            width="13"
                            height="13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 13L9 18L20 6"
                              stroke="#4cbed8"
                              strokeWidth="3.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </Box>
                      <Typography variant="body2" fontWeight={500} noWrap>
                        {num.numero}
                      </Typography>
                    </MenuItem>
                  );
                })
              }

              {numerosInternes.filter((num) => num.numero?.toLowerCase().includes(numeroInterneSearch.toLowerCase())).length === 0 && (
                <MenuItem disabled>
                  <Typography variant="body2" color="text.secondary">Aucun numéro trouvé</Typography>
                </MenuItem>
              )}
            </Select>
          </FormControl>

          {/* === MODIF : Champ Société === */}
          <FormControl fullWidth error={!!formErrors.societe_id} sx={{ mb: 2 }}>
            <InputLabel id="societe-edit-label">Société *</InputLabel>
            <Select
              labelId="societe-edit-label"
              value={updatedNomsDomaine.societe_id || ""}
              onChange={(e) => {
                const societeId = e.target.value;
                setUpdatedNomsDomaine({ ...updatedNomsDomaine, societe_id: societeId, marque: "", compte_comptable_id: "" });
                chargerComptesComptables(societeId, true);
              }} label="Société *"
              sx={{
                backgroundColor: alpha(theme.palette.background.paper, 0.95),
                borderRadius: '8px'
              }}
            >
              <MenuItem value="">
                <em>Choisir une société</em>
              </MenuItem>
              {societes.map((soc) => (
                <MenuItem key={soc.id} value={soc.id}>
                  {soc.nom}
                </MenuItem>
              ))}
            </Select>
            {formErrors.societe_id && (
              <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                {formErrors.societe_id}
              </Typography>
            )}
          </FormControl>
          <TextField
            label="Nom de Domaine"
            variant="outlined"
            fullWidth
            value={updatedNomsDomaine.nom_domaine}
            onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, nom_domaine: e.target.value })}
            error={!!formErrors.nom_domaine}
            // helperText={formErrors.nom_domaine || " "}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            required
          />
          {!customCompteComptableEdit ? (
            <FormControl
              fullWidth
              sx={{ mb: 2 }}
              disabled={!updatedNomsDomaine.societe_id || loadingComptesEdit}
              error={!!formErrors.compte_comptable_id}
            >
              <InputLabel id="compte-comptable-edit-label">Compte Comptable *</InputLabel>
              <Select
                labelId="compte-comptable-edit-label"
                value={updatedNomsDomaine.compte_comptable_id || ""}
                onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, compte_comptable_id: e.target.value })}
                label="Compte Comptable *"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              >
                <MenuItem value="" disabled>
                  {loadingComptesEdit ? "Chargement..." : "Choisir un compte"}
                </MenuItem>
                {comptesComptablesEdit.map((c) => (
                  <MenuItem key={c.id} value={c.id}>{c.code} — {c.libelle}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomCompteComptableEdit(true);
                    setUpdatedNomsDomaine({ ...updatedNomsDomaine, compte_comptable_id: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
              {formErrors.compte_comptable_id && (
                <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
                  {formErrors.compte_comptable_id}
                </Typography>
              )}
            </FormControl>
          ) : (
            <TextField
              label="Compte Comptable (saisie manuelle) *"
              variant="outlined"
              fullWidth
              autoFocus
              value={updatedNomsDomaine.compte_comptable_manuel || ""}
              onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, compte_comptable_manuel: e.target.value })}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              InputProps={{
                endAdornment: (
                  <Button
                    size="small"
                    onClick={() => { setCustomCompteComptableEdit(false); setUpdatedNomsDomaine({ ...updatedNomsDomaine, compte_comptable_manuel: "" }); }}
                    sx={{ color: "error.main", minWidth: 'auto', fontSize: '0.75rem' }}
                  >
                    ✕
                  </Button>
                )
              }}
            />
          )}
          {/* PROPRIÉTAIRE EDIT */}
          {!customProprietaireEdit ? (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ '&.Mui-focused': { color: '#2a5fa9' } }}>Propriétaire</InputLabel>
              <Select
                value={updatedNomsDomaine.proprietaire}
                onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, proprietaire: e.target.value })}
                label="Propriétaire"
                sx={{
                  borderRadius: '10px',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha('#2a5fa9', 0.2) },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9', borderWidth: 2 },
                }}
              >
                {proprietaires.map((p) => (
                  <MenuItem key={p.id} value={p.nom}>{p.nom}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomProprietaireEdit(true);
                    setUpdatedNomsDomaine({ ...updatedNomsDomaine, proprietaire: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            <Box sx={{
              mb: 2,
              borderRadius: '12px',
              border: `1.5px solid ${alpha('#2a5fa9', 0.3)}`,
              background: `linear-gradient(135deg, ${alpha('#2a5fa9', 0.03)}, ${alpha('#4cbed8', 0.03)})`,
              p: 1.5,
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{
                  width: 6, height: 6, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#2a5fa9', letterSpacing: '0.4px', textTransform: 'uppercase', fontSize: '0.7rem' }}>
                  Propriétaire
                </Typography>
              </Box>
              <TextField
                label="Propriétaire"
                fullWidth
                autoFocus
                value={updatedNomsDomaine.proprietaire}
                onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, proprietaire: e.target.value })}
                placeholder="Entrez le nom du propriétaire..."
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: alpha('#2a5fa9', 0.25) },
                    '&:hover fieldset': { borderColor: '#2a5fa9' },
                    '&.Mui-focused fieldset': { borderColor: '#2a5fa9', borderWidth: 2 },
                  },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#2a5fa9' },
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      size="small"
                      onClick={() => { setCustomProprietaireEdit(false); setUpdatedNomsDomaine({ ...updatedNomsDomaine, proprietaire: "" }); }}
                      sx={{
                        minWidth: 'auto', px: 1.5, py: 0.4,
                        borderRadius: '6px', fontSize: '0.72rem', fontWeight: 600,
                        color: theme.palette.error.main,
                        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
                        '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.08), borderColor: theme.palette.error.main },
                        whiteSpace: 'nowrap',
                      }}
                    >
                      ✕
                    </Button>
                  )
                }}
              />
            </Box>
          )}

          {/* UTILISATEUR EDIT */}
          {!customUtilisateurEdit ? (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel sx={{ '&.Mui-focused': { color: '#2a5fa9' } }}>Utilisateur</InputLabel>
              <Select
                value={updatedNomsDomaine.utilisateur}
                onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, utilisateur: e.target.value })}
                label="Utilisateur"
                sx={{
                  borderRadius: '10px',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha('#2a5fa9', 0.2) },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2a5fa9', borderWidth: 2 },
                }}
              >
                {utilisateurs.map((u) => (
                  <MenuItem key={u.id} value={u.nom}>{u.nom}</MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setCustomUtilisateurEdit(true);
                    setUpdatedNomsDomaine({ ...updatedNomsDomaine, utilisateur: "" });
                  }}
                  sx={{
                    mx: 0.5, borderRadius: '8px',
                    color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                    display: 'flex', alignItems: 'center', gap: 1,
                    '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                  }}>+</Box>
                  Saisir manuellement
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            <Box sx={{
              mb: 2,
              borderRadius: '12px',
              border: `1.5px solid ${alpha('#4cbed8', 0.3)}`,
              background: `linear-gradient(135deg, ${alpha('#4cbed8', 0.03)}, ${alpha('#65b986', 0.03)})`,
              p: 1.5,
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{
                  width: 6, height: 6, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #4cbed8, #65b986)',
                }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#4cbed8', letterSpacing: '0.4px', textTransform: 'uppercase', fontSize: '0.7rem' }}>
                  Utilisateur
                </Typography>
              </Box>
              <TextField
                label="Utilisateur"
                fullWidth
                autoFocus
                value={updatedNomsDomaine.utilisateur}
                onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, utilisateur: e.target.value })}
                placeholder="Entrez le nom de l'utilisateur..."
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    '& fieldset': { borderColor: alpha('#4cbed8', 0.25) },
                    '&:hover fieldset': { borderColor: '#4cbed8' },
                    '&.Mui-focused fieldset': { borderColor: '#4cbed8', borderWidth: 2 },
                  },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#4cbed8' },
                }}
                InputProps={{
                  endAdornment: (
                    <Button
                      size="small"
                      onClick={() => { setCustomUtilisateurEdit(false); setUpdatedNomsDomaine({ ...updatedNomsDomaine, utilisateur: "" }); }}
                      sx={{
                        minWidth: 'auto', px: 1.5, py: 0.4,
                        borderRadius: '6px', fontSize: '0.72rem', fontWeight: 600,
                        color: theme.palette.error.main,
                        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
                        '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.08), borderColor: theme.palette.error.main },
                        whiteSpace: 'nowrap',
                      }}
                    >
                      ✕
                    </Button>
                  )
                }}
              />
            </Box>
          )}

          {/* MARQUE EDIT */}

          <FormControl fullWidth sx={{ mb: 2 }} disabled={!updatedNomsDomaine.societe_id}>
            <InputLabel>Marque</InputLabel>
            <Select
              value={updatedNomsDomaine.marque}
              onChange={() => { }}
              label="Marque"
              renderValue={(selected) => selected || ""}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
              MenuProps={{
                PaperProps: { sx: { maxHeight: 320, '& .MuiList-root': { pt: 0 } } },
                disableAutoFocusItem: true,
                autoFocus: false,
              }}
              onOpen={() => setMarqueSearch("")}
            >
              <Box
                component="li"
                sx={{
                  position: 'sticky', top: 0, zIndex: 100,
                  backgroundColor: theme.palette.background.paper,
                  p: 1, listStyle: 'none',
                }}
                onClickCapture={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <TextField
                  size="small" fullWidth
                  placeholder="Rechercher une marque..."
                  value={marqueSearch}
                  onChange={(e) => setMarqueSearch(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  autoFocus
                  InputProps={{
                    startAdornment: <Search fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />,
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                    '& .MuiInputBase-root': { backgroundColor: alpha(theme.palette.background.paper, 1) },
                  }}
                />
              </Box>

              {marquesFiltrees
                .filter((m) => {
                  const zone = Array.isArray(m.zone_de_protection)
                    ? m.zone_de_protection.join(', ')
                    : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();
                  const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - ');
                  return label?.toLowerCase().includes(marqueSearch.toLowerCase());
                })
                .map((m) => {
                  const zone = Array.isArray(m.zone_de_protection)
                    ? m.zone_de_protection.join(', ')
                    : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();
                  const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - ');
                  const isSelected = updatedNomsDomaine.marque === label;
                  return (
                    <MenuItem
                      key={m.id}
                      value={label}
                      onClick={() => setUpdatedNomsDomaine({
                        ...updatedNomsDomaine,
                        marque: updatedNomsDomaine.marque === label ? "" : label
                      })}
                      sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5, py: 1,
                        '&.Mui-selected': { backgroundColor: 'transparent !important' },
                        '&.Mui-selected:hover': { backgroundColor: `${alpha('#2a5fa9', 0.05)} !important` },
                      }}
                    >
                      <Box sx={{
                        width: 20, height: 20, borderRadius: '50%',
                        border: `2px solid ${isSelected ? '#4cbed8' : alpha('#000', 0.2)}`,
                        backgroundColor: isSelected ? '#ffffff' : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, transition: 'all 0.2s ease',
                      }}>
                        {isSelected && (
                          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 13L9 18L20 6" stroke="#4cbed8" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )}
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, flexWrap: 'wrap' }}>
                        <Typography variant="body2" fontWeight={600} noWrap>
                          {m.nom}
                        </Typography>
                        {m.numero_marque && (
                          <Typography variant="caption" sx={{ color: '#2a5fa9', fontWeight: 600, fontSize: '0.72rem', whiteSpace: 'nowrap' }}>
                            N° {m.numero_marque}
                          </Typography>
                        )}
                        {m.zone_de_protection && (
                          <Box sx={{
                            display: 'inline-flex', alignItems: 'center',
                            backgroundColor: alpha('#4cbed8', 0.12),
                            border: `1px solid ${alpha('#4cbed8', 0.35)}`,
                            borderRadius: '20px', px: 0.9, py: 0.15,
                          }}>
                            <Typography variant="caption" sx={{ color: '#2a9ab5', fontWeight: 700, fontSize: '0.68rem', whiteSpace: 'nowrap' }}>
                              {Array.isArray(m.zone_de_protection)
                                ? m.zone_de_protection.join(', ')
                                : String(m.zone_de_protection).replace(/[\[\]"]/g, '').trim()
                              }
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </MenuItem>
                  );
                })
              }

              {marquesFiltrees.filter((m) => {
                const zone = Array.isArray(m.zone_de_protection)
                  ? m.zone_de_protection.join(', ')
                  : String(m.zone_de_protection || '').replace(/[\[\]"]/g, '').trim();
                const label = [m.nom, m.numero_marque, zone].filter(Boolean).join(' - ');
                return label?.toLowerCase().includes(marqueSearch.toLowerCase());
              }).length === 0 && (
                  <MenuItem disabled>
                    <Typography variant="body2" color="text.secondary">Aucune marque trouvée</Typography>
                  </MenuItem>
                )}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Statut</InputLabel>
            <Select
              value={updatedNomsDomaine.statut}
              onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, statut: e.target.value })}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              <MenuItem value="Actif">Actif</MenuItem>
              <MenuItem value="Non actif">Non actif</MenuItem>
              <MenuItem value="A fermer">A fermer</MenuItem>
              <MenuItem value="En attente">En attente</MenuItem>
              <MenuItem value="Expiré">Expiré</MenuItem>
              <MenuItem value="Renouvelé">Renouvelé</MenuItem>
              <MenuItem value="Non renouvelé">Non renouvelé</MenuItem>
              <MenuItem value="Suspendu">Suspendu</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Date Renouvellement"
            variant="outlined"
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            value={updatedNomsDomaine.date_renouvellement}
            onChange={(e) => {
              const newDate = e.target.value;
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              if (newDate && new Date(newDate) < today) {
                setError("La date de renouvellement ne peut pas être dans le passé.");
                return;
              }
              setError("");
              setUpdatedNomsDomaine({
                ...updatedNomsDomaine,
                date_renouvellement: newDate,
                periodicite: updatedNomsDomaine.automatique ? calculatePeriodicity(newDate) : updatedNomsDomaine.periodicite,
              });
            }}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Hébergeur</InputLabel>
            <Select
              value={updatedNomsDomaine.hebergeur}
              onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, hebergeur: e.target.value })}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              {hebergeurs.map((h) => (
                <MenuItem key={h.id} value={h.nom}>{h.nom}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Renouvellement HT"
            variant="outlined"
            fullWidth

            value={updatedNomsDomaine.renouvellement_ht}
            onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, renouvellement_ht: e.target.value })}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={updatedNomsDomaine.automatique}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  const newPeriodicite = isChecked && !updatedNomsDomaine.periodicite ? "1 an(s)" : updatedNomsDomaine.periodicite;
                  setUpdatedNomsDomaine({
                    ...updatedNomsDomaine,
                    automatique: isChecked,
                    periodicite: newPeriodicite,
                    date_renouvellement: isChecked ? calculateRenewalDate(newPeriodicite) : updatedNomsDomaine.date_renouvellement,
                  });
                }}
                color="primary"
              />
            }
            label="Renouvellement Automatique"
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Périodicité</InputLabel>
            <Select
              value={updatedNomsDomaine.periodicite}
              onChange={(e) => {
                const newPeriodicite = e.target.value;
                setUpdatedNomsDomaine({
                  ...updatedNomsDomaine,
                  periodicite: newPeriodicite,
                  date_renouvellement: updatedNomsDomaine.automatique ? calculateRenewalDate(newPeriodicite) : updatedNomsDomaine.date_renouvellement,
                });
              }}
              disabled={!updatedNomsDomaine.automatique}
              error={!!formErrors.periodicite}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
            >
              {[...Array(10).keys()].map((i) => (
                <MenuItem key={i + 1} value={`${i + 1} an(s)`}>{i + 1} an(s)</MenuItem>
              ))}
            </Select>
            {formErrors.periodicite && (
              <Typography variant="caption" color="error" sx={{ ml: 1.75, mt: 0.5, display: 'block' }}>
                {formErrors.periodicite}
              </Typography>
            )}
          </FormControl>
          <TextField
            label="Commentaires"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={updatedNomsDomaine.commentaires}
            onChange={(e) => setUpdatedNomsDomaine({ ...updatedNomsDomaine, commentaires: e.target.value })}
            sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '8px' }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelUpdate}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
              },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleUpdateConfirm}
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '8px',
              background: alpha(theme.palette.primary.main, 0.8),
              '&:hover': {
                background: theme.palette.primary.main,
                transform: 'scale(1.05)',
              },
            }}
          >
            Mettre à jour
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        PaperProps={{
          sx: {
            background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.paper, 0.95)} 100%)`,
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            minWidth: 450,
            px: 2,
            py: 1,
          },
        }}
      >
        <DialogTitle>
          <SectionTitle>Supprimer le nom de domaine</SectionTitle>
        </DialogTitle>
        <DialogContent>
          <Typography variant="caption" sx={{ color: 'text.primary', display: 'block', textAlign: 'center', mt: 1, fontSize: '0.95rem' }}>
            Voulez-vous vraiment supprimer ce nom de domaine ?
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.primary', display: 'block', textAlign: 'center', mt: 1, fontSize: '0.95rem' }}>
            Cette action est irréversible.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDelete(false)}
            sx={{
              color: theme.palette.error.main,
              '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
              },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            color="error"
            sx={{
              borderRadius: '8px',
              background: alpha(theme.palette.error.main, 0.8),
              '&:hover': {
                background: theme.palette.error.main,
                transform: 'scale(1.05)',
              },
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NomsDomaines;